import React from "react";

export const TemplatePreviewDialog: React.FC<{
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
}> = ({ open, onClose, children, title }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100]">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} aria-hidden="true" />
      <div className="absolute inset-0 flex items-center justify-center p-4">
    <div className="w-full max-w-[500px]" role="dialog" aria-modal="true" aria-label={title || "Live Preview"}>
          <div className="rounded-3xl overflow-hidden bg-white shadow-2xl">
            <div className="flex items-center justify-between px-4 py-3 border-b">
              <div className="text-sm font-semibold">{title || "Live Preview"}</div>
              <button onClick={onClose} className="text-sm text-gray-600 hover:text-gray-900">Close</button>
            </div>
      <div className="bg-gray-100 p-3 max-h-[85vh] overflow-auto">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
